export const DOWNLOAD_CSV = {
  pt: "Baixar em Excel",
  es: "Descargar en Excel",
  en: "Download in Excel",
};
